import axios from 'axios'

const state = {
    openCustomizer: false,
    modeCustomizer: 'create',
    productId: null,
    attributes: null,
    variations: null,
    loading: true,
    step: null,
    steps: null,
    totalSteps: 1,
    product: null,
    products: null,
    totalPrice: 0,
    options: {
        pa_additionals: [],
        pa_materac: null,
        group: null,
        custom_fabric: null
    },
    related: [],
    complementary: [],
    optionsEmpty: null,
    priceDiffs: null,
    confirmationDialog: {
        open: false,
        step: null,
        header: null,
        message: null,
        confirm: false,
        data: null
    },
    complementaryDialog: {
        header: null,
        message: null,
        open: false,
        step: null,
        confirm: false
    },
    copyVariation: {
        options: {
            pa_additionals: [],
            pa_materac: null,
            group: null,
            custom_fabric: null
        },
        product: null
    },
    fabrics: null
}

const mutations = {
    setAttributes(state, attributes) {
        state.attributes = attributes
    },
    setVariations(state, variations) {
        state.variations = variations
    },
    setAttributesFormat(state, attributes) {
        const all = JSON.parse(JSON.stringify(state.options))
        state.options = {...all, ...attributes}
        state.optionsEmpty = {...state.options}
    },
    setOptionArrangement(state, arrangement) {
        state.options.pa_uklad = arrangement
        state.step.completed = true
        state.related = []
    },
    setOptionFabric(state, fabric) {
        state.options.pa_tkanina = fabric
        state.step.completed = !!state.options.pa_tkanina
        state.options.custom_fabric = null
        state.related = []
    },
    setFabricCustom(state, fabric) {
        state.options.custom_fabric = fabric
        state.options.pa_tkanina = 'tkanina-z-probnika'
        state.step.completed = !!state.options.pa_tkanina
    },
    setOptionAdditionals(state, additionals) {
        state.options[additionals.step] = additionals.value
        state.step.completed = !!state.options[additionals.step]
        //
        if (additionals.step === 'pa_tkanina') {
            state.related = []
        }
    },
    setOptionImage(state, image) {
        state.options.image = image
    },
    setOptionFabricV(state, fabric) {
        state.options.pa_tkanina = fabric
    },
    setOptionGroup(state, group) {
        state.options.group = group
    },
    setOptionMattress(state, option) {
        state.options.pa_materac = option
        state.step.completed = true
    },
    setStep(state, step) {
        state.step = step
    },
    setSteps(state, steps) {
        state.steps = steps
        state.step = steps[0]
        state.confirmationDialog.step = steps[0]
    },
    setStepCompleted(state, completed) {
        state.step.completed = completed
    },
    setPrevStep(state, step) {
        const value = state.steps.find(item => item.id === step)
        state.step = {...value, completed: true}
    },
    setNextStep(state, step) {
        state.step = state.steps.find(item => item.id === step)
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setTotalSteps(state, steps) {
        state.totalSteps = steps
    },
    setAdditionals(state, additionals) {
        state.options.pa_additionals = additionals
    },
    setCustomizerOpen(state, open) {
        state.openCustomizer = open
    },
    setCustomizerExit(state) {
        state.openCustomizer = false
        state.options = JSON.parse(JSON.stringify(state.optionsEmpty))
        state.product.variation = null
        state.modeCustomizer = 'create'
        state.step = state.steps[0]
    },
    setCustomizerEdit(state, step) {
        state.openCustomizer = true
        state.modeCustomizer = 'edit'
        state.step = step
    },
    setCustomizerMode(state, mode) {
        state.modeCustomizer = mode
    },
    setTotalPrice(state, price) {
        state.totalPrice = price
    },
    setProduct(state, product) {
        state.product = product
    },
    resetOptions(state, options) {
        state.product.variation = null
        state.options = JSON.parse(JSON.stringify(state.optionsEmpty))
        state.modeCustomizer = 'create'
        state.step = state.steps[0]
    },
    setOption(state, value) {
        state.options[value.id] = value.data
    },
    setOptions(state, value) {
        state.options = value
    },
    setPriceDiffs(state, value) {
        state.priceDiffs = value
    },
    setProductId(state, id) {
        state.productId = id
    },
    setRelated(state, related) {
        state.related = related
    },
    setComplementary(state, complementary) {
        state.complementary = complementary
    },
    setConfirmationDialogOpen(state, value) {
        state.confirmationDialog.open = value
    },
    setConfirmationDialogStep(state, value) {
        state.confirmationDialog.step = value
    },
    setConfirmationDialogConfirm(state, value) {
        state.confirmationDialog.confirm = value
    },
    setConfirmationDialogData(state, value) {
        state.confirmationDialog.data = value
    },
    setConfirmationDialogContent(state, value) {
        state.confirmationDialog.header = value.header
        state.confirmationDialog.message = value.message
    },
    setComplementaryDialogOpen(state, value) {
        state.complementaryDialog.open = value
    },
    setComplementaryDialogStep(state, value) {
        state.complementaryDialog.step = value
    },
    setComplementaryDialogContent(state, value) {
        state.complementaryDialog.header = value.header
        state.complementaryDialog.message = value.message
    },
    setComplementaryDialogConfirm(state, value) {
        state.complementaryDialog.confirm = value
    },
    setCopyVariation(state, variation) {
        Object.assign(state.copyVariation, variation)
    },
    setFabrics(state, fabrics) {
        state.fabrics = fabrics
    }
}

const getters = {
    getAttributes(state) {
        return state.attributes
    },
    getVariations(state) {
        return state.variations
    },
    getOptions(state) {
        return state.options
    },
    getStep(state) {
        return state.step
    },
    getSteps(state) {
        return state.steps
    },
    getLoading(state) {
        return state.loading
    },
    getProduct(state) {
        return state.product
    },
    getProductData(state) {
        if (!state.product) {
            return state.product
        }

        return state.product.variation ? state.product.variation : state.product.product
    },
    getTotalSteps(state) {
        return Object.keys(state.steps).length
    },
    getAdditionals(state) {
        return state.options.pa_additionals
    },
    getCustomizerOpen(state) {
        return state.openCustomizer
    },
    getCustomizerMode(state) {
        return state.modeCustomizer
    },
    getTotalPrice(state) {
        return state.totalPrice
    },
    getPriceDiffs(state) {
        return state.priceDiffs
    },
    getRelated(state) {
        return state.related
    },
    getComplementary(state) {
        return state.complementary
    },
    getConfirmationDialogOpen(state) {
        return state.confirmationDialog.open
    },
    getConfirmationDialogStep(state) {
        return state.confirmationDialog.step
    },
    getConfirmationDialogConfirm(state) {
        return state.confirmationDialog.confirm
    },
    getConfirmationDialogData(state) {
        return state.confirmationDialog.data
    },
    getConfirmationDialogContent(state) {
        return {
            header: state.confirmationDialog.header,
            message: state.confirmationDialog.message
        }
    },
    getComplementaryDialogOpen(state) {
        return state.complementaryDialog.open
    },
    getComplementaryDialogStep(state) {
        return state.complementaryDialog.step
    },
    getComplementaryDialogContent(state) {
        return {
            header: state.complementaryDialog.header,
            message: state.complementaryDialog.message
        }
    },
    getComplementaryDialogConfirm(state,) {
        return state.complementaryDialog.confirm
    },
    getCopyVariation(state) {
        return state.copyVariation
    },
    getFabrics(state) {
        return state.fabrics
    }
}

const actions = {
    fetchAttributeFabric({commit, dispatch}, data) {
        return new Promise((resolve, reject) => {
            commit('setLoading', f)
            axios.get(process.env.VUE_APP_API + '/wp-json/ramaro/attributes/fabric')
                .then((res) => {
                    commit('setFabrics', res.data)
                    commit('setLoading', false)
                    resolve(res.data)
                })
                .catch(async (err) => {
                    reject(err)
                })
        });
    },
    fetchProduct({commit, dispatch}, data) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            axios.get(process.env.VUE_APP_API + '/wp-json/ramaro/product/' + data + '/steps')
                .then((res) => {
                    commit('setSteps', res.data)
                    commit('setStep', res.data[0])

                    axios.get(process.env.VUE_APP_API + '/wp-json/ramaro/product/' + data + '/attributes')
                        .then((res) => {
                            resolve(res)
                            commit('setAttributes', res.data)
                            const values = Object.keys(res.data).reduce((acc, curr) => (acc[curr] = null, acc), {})

                            commit('setAttributesFormat', values)
                            commit('setLoading', false)
                        })
                        .catch(async (err) => {
                            reject(err)
                        })
                })
                .catch(async (err) => {
                    reject(err)
                })
            // axios.get('https://ramaro.ds-lab.pl/wp-json/ramaro/product/5811')
            //     .then((res) => {
            //         commit('setLoading', false)
            //         // commit('setProduct', { product: res.data })
            //         resolve(res)
            //     })
            //     .catch(async (err) => {
            //         reject(err)
            //     })
            // axios.get('https://ramaro.ds-lab.pl/wp-json/ramaro/product/' + data + '/variations')
            //     .then((res) => {
            //         resolve(res)
            //         commit('setVariations', res.data)
            //         commit('setProduct', res.data.product)
            //         commit('setLoading', false)
            //     })
            //     .catch(async (err) => {
            //         reject(err)
            //     })
        });
    },
    fetchVariation({commit, state, dispatch}, data) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)

            let attributes = null
            const dataAttributes = data

            if (data) {

                let attr = JSON.parse(JSON.stringify(data))

                delete attr.group
                delete attr.pa_additionals
                delete attr.custom_fabric
                delete attr.pa_materac

                    // Object.filter = (obj, predicate) =>
                    //     Object.assign(...Object.keys(obj)
                    //         .filter(key => predicate(obj[key]))
                    //         .map(key => ({[key]: obj[key]})));

                if (attr) {
                    // const attributes = data.filter(attribute => attribute !== null)
                    // attributes = Object.filter(attr, item => item !== null)
                    attributes = Object.fromEntries(Object.entries(attr).filter(([_, v]) => v != null));
                }
            }
            axios.get(process.env.VUE_APP_API + '/wp-json/ramaro/product/' + state.productId + '/variation', {params: attributes})
                .then((res) => {
                    commit('setLoading', false)
                    commit('setProduct', res.data)
                    if (state.copyVariation && !state.copyVariation.product) {
                        commit('setCopyVariation', {
                            ...res.data,
                            options: JSON.parse(JSON.stringify(dataAttributes))
                        })
                    }
                    resolve(res)
                })
                .catch(async (err) => {
                    reject(err)
                })
        })
    },
    changeDefaults(data) {
        const options = JSON.parse(JSON.stringify(data))

        delete options.pa_additionals
        delete options.group
        delete options.custom_fabric

        Object.keys(options).forEach((item) => {
            if (options[item]) {
                const select = document.querySelector(`select#${item}`)
                if (select) {
                    select.value = options[item]
                    select.dispatchEvent(new Event("change", {"bubbles": true}))
                }
            }
        })
    },
    addToCart({commit, state}, data) {
        return new Promise((resolve, reject) => {
            const addToCart = async (products) => {

                let params = new FormData()
                let productsList = []
                params.append('action', 'ramaro_add_to_cart')
                products.forEach((item) => {
                    params.append('products[]', JSON.stringify(item))
                    productsList.push(JSON.stringify({
                        product_id: item.product_id,
                        variation_id: item.variation_id || null,
                        quantity: item.quantity,
                        price: item.price,
                        custom_product: item.custom_product || null,
                        custom_fabric: item.custom_fabric || null,
                        custom_arrangement: item.custom_arrangement || null,
                    }))
                })

                await axios.post(process.env.VUE_APP_API  + '/wp-admin/admin-ajax.php', params).then(function (response) {
                    resolve(response)

                    document.body.dispatchEvent(new CustomEvent("ramaro_added_to_cart", {detail: productsList}));

                    document.body.dispatchEvent(new Event('wc_fragment_refresh'));

                }).catch((err) => {
                    reject(err)
                })
            }

            addToCart(data)

            // if(data.hasOwnProperty('additionals') && Array.isArray(data.additionals)) {
            //     data.additionals.forEach((item) => {
            //         addToCart(item)
            //     })
            // }

        });
    },
    addToCartFabric({commit, state}, data) {
        return new Promise((resolve, reject) => {
            const addToCart = async (products) => {

                let params = new FormData()
                params.append('action', 'ramaro_add_to_cart')
                params.append('products[]', JSON.stringify(products))

                await axios.post(process.env.VUE_APP_API  + '/wp-admin/admin-ajax.php', params).then(function (response) {
                    resolve(response)

                    document.body.dispatchEvent(new Event('wc_fragment_refresh'));

                }).catch((err) => {
                    reject(err)
                })
            }

            addToCart(data)

            // if(data.hasOwnProperty('additionals') && Array.isArray(data.additionals)) {
            //     data.additionals.forEach((item) => {
            //         addToCart(item)
            //     })
            // }

        });
    },
    resetCustomizer({commit, state}) {
        return new Promise((resolve, reject) => {
            commit('setCustomizerExit')
            commit('resetOptions')
            if (window.location.search.includes('attribute_pa')) {
                commit('setProduct', {
                    product: state.copyVariation.product,
                    variation: state.copyVariation.variation
                })
                commit('setOptions', state.copyVariation.options)

                return
            }

            const reset = document.querySelector('a.reset_variations')
            if (reset) reset.dispatchEvent(new Event("click", {"bubbles": true}))

            resolve()
        })
    },
    priceDifferents({commit, state}) {
        return new Promise((resolve, reject) => {

            const product = state.variations.product

            let steps = JSON.parse(JSON.stringify(state.steps))
            const priceDiff = []
            let options = JSON.parse(JSON.stringify(state.options))

            // const additional = steps.findIndex(step => step.id === 'pa_additionals')
            // steps.splice(additional, 1)
            //
            // const arrange = steps.findIndex(step => step.id === 'pa_uklad')
            // steps.splice(arrange, 1)

            steps.forEach((item, index) => {
                const stepIndex = steps.findIndex(step => step.id === item.id)
                const stepsBefore = stepIndex === 0 ? [steps[0].id] : steps.slice(0, stepIndex + 1).map(item => item.id)
                let values = {}

                console.log(stepsBefore)


                stepsBefore.forEach((key) => {
                    if (options.hasOwnProperty(key)) {
                        values[key] = options[key]
                    }
                })


                const value = state.variations.variations.filter((item) => {
                    for (const v in item.attributes) {
                        if (values[v] && values[v] !== item.attributes[v]) {
                            return false
                        }
                    }
                    return true;
                })

                priceDiff.push({...value[0], step: item.id})
            })


            let prices = {}
            priceDiff.forEach((item, index) => {
                const prev = index > 0 ? priceDiff[index - 1] : null
                if (prev) {
                    prices[item.step] = {
                        price: item.price,
                        diff: Math.abs(item.price - prev.price)
                    }
                } else {
                    prices[item.step] = {price: item.price, diff: Math.abs(product.price - item.price)}
                }
            })

            commit('priceDiffs', prices)
            console.log(prices)

            resolve(prices)
        })
    },
    fetchProductRelated({commit, state}) {
        commit('setLoading', true)

        return new Promise((resolve, reject) => {
            const attributes = JSON.parse(JSON.stringify(state.options))
            delete attributes.group
            delete attributes.pa_additionals
            const data = {
                products: state.product.product.related.map(product => product.id),
                attributes: attributes
            }
            axios.post(process.env.VUE_APP_API  + '/wp-json/ramaro/product/' + state.product.product.id + '/related', data)
                .then((res) => {
                    let data = JSON.parse(JSON.stringify(res.data))
                    const related = data.map(obj => ({...obj, quantity: 1}))
                    resolve(related)
                    commit('setRelated', related)
                    commit('setLoading', false)
                })
                .catch(async (err) => {
                    reject(err)
                    commit('setLoading', false)
                })
        })
    },
    fetchProductComplementary({commit, state}, data) {
        commit('setLoading', true)

        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API  + '/wp-json/ramaro/product/' + state.product.product.id + '/complementary', data)
                .then((res) => {
                    let data = JSON.parse(JSON.stringify(res.data))
                    const related = data.map(obj => ({...obj, quantity: 1}))
                    resolve(related)
                    commit('setComplementary', related)
                    commit('setLoading', false)
                })
                .catch(async (err) => {
                    reject(err)
                    commit('setLoading', false)
                })
        })
    },
    initResetCustomizer({commit, state, dispatch}) {
        commit('setLoading', true)
        setTimeout(() => {
            const url = document.querySelector('#customizer-container').dataset.productUrl
            window.history.replaceState({ product: 'Updated' }, document.title, url)
            dispatch('resetCustomizer')
            commit('setLoading', false)
            document.querySelector('.single_add_to_cart_button.cloned').remove()

            const productPrice = document.querySelector('.product-summary-wrap .price span.amount')
            if (productPrice) {
                productPrice.innerHTML = new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(state.product.product.price)
            }
        }, 500)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
